import React, {useRef} from 'react'
import {Grid, Slider, Typography, IconButton} from '@material-ui/core'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline'
import useStyles from './BarcodeLabelZoom.styles'

function BarcodeLabelZoom(props) {
  const classes = useStyles()
  const refTimeout = useRef()
  const [value, setValue] = React.useState(props.zoom || 1)

  const handleSliderChange = (e, newValue) => {
    setValue(newValue)
    if (refTimeout.current) {
      clearTimeout(refTimeout.current)
      refTimeout.current = undefined
    }
    refTimeout.current = setTimeout(() => {
      props.onChange(newValue)
    }, 250)
  }

  const handleZoomIn = e => {
    if (value <= 0.5) return

    setValue(value - 0.5)
    if (refTimeout.current) {
      clearTimeout(refTimeout.current)
      refTimeout.current = undefined
    }
    refTimeout.current = setTimeout(() => {
      props.onChange(value - 0.5)
    }, 250)
  }

  const handleZoomOut = e => {
    if (value >= 5) return

    setValue(value + 0.5)
    if (refTimeout.current) {
      clearTimeout(refTimeout.current)
      refTimeout.current = undefined
    }
    refTimeout.current = setTimeout(() => {
      props.onChange(value + 0.5)
    }, 250)
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={1} alignItems="center">
        <Grid item style={{minWidth: 48}}>
          <Typography>{value * 100}%</Typography>
        </Grid>
        <Grid item>
          <IconButton size="small" onClick={handleZoomIn}>
            <RemoveCircleOutlineIcon />
          </IconButton>
        </Grid>
        <Grid item xs>
          <Slider
            min={0.5}
            max={5}
            step={0.5}
            value={typeof value === 'number' ? value : 0}
            onChange={handleSliderChange}
            aria-labelledby="input-slider"
            style={{verticalAlign: 'middle'}}
          />
        </Grid>
        <Grid item>
          <IconButton size="small" onClick={handleZoomOut}>
            <AddCircleOutlineIcon />
          </IconButton>
        </Grid>
      </Grid>
    </div>
  )
}

export default BarcodeLabelZoom
